// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23pO0","index":"styles_index__2UDs2"};